import { render } from "./PatientInsuranceForm.vue?vue&type=template&id=767f9c96&scoped=true"
import script from "./PatientInsuranceForm.vue?vue&type=script&lang=js"
export * from "./PatientInsuranceForm.vue?vue&type=script&lang=js"

import "./PatientInsuranceForm.vue?vue&type=style&index=0&id=767f9c96&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-767f9c96"]])

export default __exports__